import { c as _c } from "react/compiler-runtime";
import { buildImageProps } from "@/lib/sanity/sanityImageUrlBuilder";
import { Review, ReviewPreview } from "@/lib/types/review";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
interface ReviewCardProps {
  review: Review | ReviewPreview;
  className?: string;
}
function getReviewerInitials(name: string) {
  return name.split(" ").filter(Boolean).slice(0, 2).map(part => part[0]?.toUpperCase() ?? "").join("");
}
function ReviewCard(t0) {
  const $ = _c(29);
  const {
    review
  } = t0;
  let t1;
  if ($[0] !== review.image) {
    t1 = review.image ? buildImageProps(review.image, {
      width: 120
    }) : undefined;
    $[0] = review.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageProps = t1;
  let t2;
  if ($[2] !== review.name) {
    t2 = getReviewerInitials(review.name);
    $[2] = review.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const initials = t2;
  let t3;
  if ($[4] !== review.heading) {
    t3 = <CardHeader><CardTitle className="text-lg 2xl:text-2xl">{review.heading}</CardTitle></CardHeader>;
    $[4] = review.heading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== review) {
    t4 = "text" in review && <CardContent className="flex-1 mb-2 2xl:mb-2"><blockquote className="text-pretty text-sm md:text-base 2xl:text-xl">{review.text}</blockquote></CardContent>;
    $[6] = review;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== imageProps) {
    t5 = imageProps && <AvatarImage src={String(imageProps.src)} alt={imageProps.alt} />;
    $[8] = imageProps;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== initials) {
    t6 = <AvatarFallback>{initials}</AvatarFallback>;
    $[10] = initials;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Avatar className="size-11 border">{t5}{t6}</Avatar>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== review.name) {
    t8 = <span className="font-semibold">{review.name}</span>;
    $[15] = review.name;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== review.company) {
    t9 = review.company && <cite className="text-sm not-italic text-muted-foreground">{review.company}</cite>;
    $[17] = review.company;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex flex-col leading-tight">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <CardFooter className="flex items-center gap-3">{t7}{t10}</CardFooter>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t3 || $[27] !== t4) {
    t12 = <Card className="max-w-90 md:max-w-150 gap-1 2xl:gap-2">{t3}{t4}{t11}</Card>;
    $[25] = t11;
    $[26] = t3;
    $[27] = t4;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
export { ReviewCard };